module.exports = __webpack_public_path__ + "static/img/solutionDetailPic24.152eda7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic24.png
// module id = nbeI
// module chunks = 1